import { render, staticRenderFns } from "./r-worker-key.vue?vue&type=template&id=c006791e"
import script from "./r-worker-key.vue?vue&type=script&lang=js"
export * from "./r-worker-key.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c006791e')) {
      api.createRecord('c006791e', component.options)
    } else {
      api.reload('c006791e', component.options)
    }
    module.hot.accept("./r-worker-key.vue?vue&type=template&id=c006791e", function () {
      api.rerender('c006791e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/worker/r-worker-key.vue"
export default component.exports